var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55332e-08 7.50276C-0.000274862 5.29985 1.59451 3.42069 3.76815 3.06272C4.97155 0.918943 7.36114 -0.273621 9.79772 0.0535596C12.2343 0.38074 14.2246 2.16144 14.8199 4.54673C16.7576 4.84448 18.1389 6.58479 17.9889 8.53954C17.8388 10.4943 16.2082 12.0035 14.2477 12.002H4.49928C2.0144 12.002 3.55332e-08 9.98764 3.55332e-08 7.50276Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4937f95bdf8b0dac348483e7974a5dc7.svg";
export { ForwardRef as ReactComponent };